import { createSlice } from '@reduxjs/toolkit';

import { getLessons } from './actions';

import { removeLessonById } from '../lesson/actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 10,
};

const lessonsSlice = createSlice({
  name: 'lessons',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getLessons.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(removeLessonById.fulfilled, (state: any, action: any) => {
      return {
        ...state,
        data: state.data.filter(
          (lesson: any) => lesson.id !== action.payload?.id,
        ),
      };
    });
  },
});

export default lessonsSlice.reducer;
